import React, { useState } from 'react';
import { LogoHeader } from '../../Components/Inicio/LogoHeaderComponent';
import { NavMobile } from '../../Components/Inicio/NavMobile';
import { NavDesktop } from '../../Components/Inicio/NavDesktop';
import { Footer } from '../../Components/Footer/FooterComponent';
import { Notification } from '../../Components/NotificationLoginComponent'; 
import { ContactMessagesComponent } from '../../Components/ContactMessagesComponent';

export const ContactMessagesPage = (props) => {
    const [showNotification, setShowNotification] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isErrorNoti, setErrorNoti] = useState(false);

    const handleNotification = (message, type) => {
        setErrorMessage(message);
        setErrorNoti(type === 'error');
        setShowNotification(true);
        setTimeout(() => {
            setShowNotification(false);
        }, 5000);
    };

    return (
        <>
            <LogoHeader I18n={props.I18n} />
            <NavDesktop I18n={props.I18n} />
            <NavMobile I18n={props.I18n} />
            {showNotification && <Notification message={errorMessage} type={isErrorNoti ? "error" : "success"} />}
            <ContactMessagesComponent handleNotification={handleNotification} I18n={props.I18n} user={props.User}/>

            <Footer I18n={props.I18n} />
        </>
    );
};
